import { adobeConfig } from "@abbvie-epi/common/adobe-analytics/adobe-analytics.config";

export const baseEnvironment = {
    production: false,
    version: "", // Set in version.json via build environment variables
    buildNumber: "", // Set in version.json via build environment variables
    commitHash: "", // Set in version.json via build environment variables
    environmentName: "development", // Set in version.json via build environment variables
    enableLocalSentryCapture: false,
    adobeAnalyticsConfig: adobeConfig,
    apiHost: "/"
};
